import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";
import { GET_ADMIN_TEST_RESULTS_TABLE } from "../../services/urls";

const initialState = {
  loading: false,
  rows: [],
  total: 0,
  page: 1,
  limit: 10,
  totalPages: 1,
  error: null,
};

export const fetchAdminTestResults = createAsyncThunk(
  "testResults/fetchAdminTestResults",
  async ({ page = 1, limit = 10, search = "" }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
      });
      if (search?.trim()) {
        params.set("search", search.trim());
      }
      const response = await api.get(`${GET_ADMIN_TEST_RESULTS_TABLE}?${params}`);
      const result = response.data?.data ?? response.data;
      return {
        data: Array.isArray(result?.data) ? result.data : [],
        total: result?.total ?? 0,
        page: result?.page ?? 1,
        limit: result?.limit ?? 10,
        totalPages: result?.totalPages ?? 1,
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch test results"
      );
    }
  }
);

const testResultsSlice = createSlice({
  name: "testResults",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminTestResults.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminTestResults.fulfilled, (state, action) => {
        state.loading = false;
        state.rows = Array.isArray(action.payload?.data) ? action.payload.data : [];
        state.total = action.payload?.total || 0;
        state.page = action.payload?.page || 1;
        state.limit = action.payload?.limit || 10;
        state.totalPages = action.payload?.totalPages || 1;
      })
      .addCase(fetchAdminTestResults.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default testResultsSlice.reducer;
